import React from 'react';
import { Tooltip as ReactTooltip, PlacesType, Middleware } from 'react-tooltip';
import {
  acquireEmbedSubmenuBleed,
  releaseEmbedSubmenuBleed,
} from '../../../../hooks/useEmbedSubmenuBleed';
import './CustomTooltip.scss';

interface CustomTooltipProps {
  id?: string;
  place?: PlacesType;
  variant?: 'dark' | 'light' | 'success' | 'warning' | 'error' | 'info';
  positionStrategy?: 'absolute' | 'fixed';
  className?: string;
  offset?: number;
  noArrow?: boolean;
  delayShow?: number;
  delayHide?: number;
  openEvents?: any;
  closeEvents?: any;
  globalCloseEvents?: any;
  closeOnScroll?: boolean;
  closeOnResize?: boolean;
  middlewares?: Middleware[];
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  id = 'chatbot-tooltip',
  place = 'top',
  variant = 'light',
  positionStrategy = 'absolute',
  className = '',
  offset = 10,
  noArrow = false,
  delayShow = 200,
  delayHide = 0,
  openEvents,
  closeEvents,
  globalCloseEvents,
  closeOnScroll,
  closeOnResize,
  middlewares,
}) => {
  // Tooltip sát mép trái panel → nới iframe như submenu để không bị host clip-path cắt
  const isBleedingRef = React.useRef(false);

  const handleAfterShow = React.useCallback(() => {
    if (isBleedingRef.current) return;
    isBleedingRef.current = true;
    acquireEmbedSubmenuBleed();
  }, []);

  const handleAfterHide = React.useCallback(() => {
    if (!isBleedingRef.current) return;
    isBleedingRef.current = false;
    releaseEmbedSubmenuBleed();
  }, []);

  React.useEffect(() => handleAfterHide, [handleAfterHide]);

  return (
    <ReactTooltip
      id={id}
      place={place}
      variant={variant}
      positionStrategy={positionStrategy}
      className={className || 'custom-chatbot-tooltip'}
      delayShow={delayShow}
      delayHide={delayHide}
      offset={offset}
      opacity={1}
      noArrow={noArrow}
      afterShow={handleAfterShow}
      afterHide={handleAfterHide}
      openEvents={openEvents}
      closeEvents={closeEvents}
      globalCloseEvents={globalCloseEvents}
      closeOnScroll={closeOnScroll}
      closeOnResize={closeOnResize}
      middlewares={middlewares}
      style={{
        zIndex: 99999, // Ensure it's on top of everything including overlays
      }}
    />
  );
};

export default CustomTooltip;
